import React from "react";
import { KTMScreen, ActionEvent, RenderEvent, renderScreen } from "ktm-ui";
import { KTMApi } from "api/KTMApi";
import { Layout, Dialog, Button, Column, Panel, Display, Card, Line} from "ktm-ui";
import CustomToolTip from 'components/CustomToolTip';

interface IdsBenCat {
  Id: string;
  Name: string;
  Description: string;
  Policy_Id: string;
  ExcludeTeladoc: boolean;
  ExcludeCorehealth: boolean;
}

interface IdsPolicy {
    Id: string;
    HasTeladoc: boolean;
    HasCorehealth: boolean;
}

export default KTMScreen(
  { name: "enroll.bencat.new" },
  class extends React.Component<{ policy_id: string }> {
    data: {
      dsBenCat: IdsBenCat;
      dsPolicy: IdsPolicy;
    };

    // Store original data for comparison
    originalData: IdsBenCat | null = null;

    render() {
      return renderScreen(this);
    }

    async start({ screen }: ActionEvent) {
      screen.defaultRecord = "@dsBenCat";
      await KTMApi.start(screen, {
        "@policy_id": this.props.policy_id,
      });
      screen.title = "New Benefit Category";

      // Store a copy of the original data
      this.originalData = { ...this.data.dsBenCat };
    }

    main({ field, draw, action }: RenderEvent) {
      return (
        <Layout>
          {draw(this.header)}
          {draw(this.main_tab)}
          {draw(this.footer)}
        </Layout>
      );
    }

    header({ field, draw, action }: RenderEvent) {
      return <Dialog.Header label="New Benefit Category" />;
    }

    footer({ field, draw, action }: RenderEvent) {
      var isDisabled =
        this.data.dsBenCat.Name === null ||
        this.data.dsBenCat.Description === null ||
        this.data.dsBenCat.Name === undefined ||
        this.data.dsBenCat.Description === undefined
          ? true
          : false;

      return (
        <Dialog.Footer>
          <Button
            action={action(this.submit)}
            label="Save"
            size="large"
            style="primary"
            disable={isDisabled}
          />
        </Dialog.Footer>
      );
    }

    main_tab({ field, draw, action }: RenderEvent) {
      return (
        <Panel>
          <Column>{draw(this.details)}</Column>
        </Panel>
      );
    }

    details({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Display field={field("Name")} />
          <Display field={field("Description")} />
         {(this.data.dsPolicy.HasTeladoc || this.data.dsPolicy.HasCorehealth) && <>
              <Line>
                  {this.data.dsPolicy.HasTeladoc ? (
                      <span style={{ color: 'red' }}>
                          <Display field={field("ExcludeTeladoc")} />
                      </span>
                  ) : <></>}
                  {this.data.dsPolicy.HasCorehealth ? (
                      <span style={{ color: 'red' }}>
                          <Display field={field("ExcludeCorehealth")} />
                      </span>
                  ) : <></>}
              </Line>
          </>}
        </Card>
      );
    }

    getChangedFields(originalData, updatedData) {
      if (!originalData) return {};

      const changes = {};
      for (const key in updatedData) {
        if (updatedData[key] !== originalData[key]) {
          changes[key] = {
            oldValue:
              originalData[key] !== undefined ? originalData[key] : "N/A",
            newValue: updatedData[key] !== undefined ? updatedData[key] : "N/A",
          };
        }
      }
      return changes;
    }
    
    async submit({ screen }: ActionEvent) {
      // Track changes
      const changes = this.getChangedFields(
        this.originalData,
        this.data.dsBenCat
      );

      const logDetails = Object.entries(changes)
        .map(([key, value]) => {
          const change = value as { oldValue: any; newValue: any };
          return `${key}: ${change.oldValue} → ${change.newValue}`;
        })
        .join(" | ");

      const policyLogs = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Note: logDetails,
          Action: "Policy Add new Benefit Category",
          PolicyId: this.props.policy_id,
        }),
      };

      await KTMApi.action(screen, "submit", {
        "@dsBenCat.Name": this.data.dsBenCat.Name,
        "@dsBenCat.Description": this.data.dsBenCat.Description,
        "@dsBenCat.ExcludeTeladoc": this.data.dsBenCat.ExcludeTeladoc,
        "@dsBenCat.ExcludeCorehealth": this.data.dsBenCat.ExcludeCorehealth,
        "@policy_id": this.props.policy_id,
      }).then(() => {
        fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
      });
      screen.close({ continue: true });
    }
  }
);
